import axios, { type Canceler } from "axios";
import { type SasConfig } from "../../../../interfaces";

const service = {
  createSas: (config: SasConfig, acceptCancelationHandler: (c: { abort: Canceler }) => void) => {
    return axios.post(config.endpointToGetSasLink, config.sasRequest, {
      cancelToken: new axios.CancelToken((c) => acceptCancelationHandler && acceptCancelationHandler({ abort: c })),
    });
  },
};

export default service;
